// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__c_bpM","footer":"ModalError_footer__3zpui"};